import AlertModal from 'components/common/AlertModal';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import { DisplayControlGroup } from 'features/DisplayControlGroup/models';
import { Formik } from 'formik';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import service from '../services';

interface PropsData {
  object: DisplayControlGroup | undefined;
  id: number;
  handleCloseModalEdit: (status: boolean, data: DisplayControlGroup) => void;
  dataTable?: DisplayControlGroup[];
  setDataTable?: (objects: DisplayControlGroup[]) => void;
}

function FormDetail({ object, id, handleCloseModalEdit, dataTable, setDataTable }: PropsData) {
  const { t } = useTranslation();
  const { showGlobalModal } = useGlobalModal();
  const schema = yup.object().shape({
    name: yup.string().required(t('DisplayControlGroup.Validator.name')),
  });

  const initialValues: DisplayControlGroup = {
    id: object?.id ? object.id : 0,
    name: object?.name ? object.name : '',
    display_name: object?.display_name ? object.display_name : '',
    display_name_ja: object?.display_name_ja ? object.display_name_ja : '',
    display_name_en: object?.display_name_en ? object.display_name_en : '',
    display_name_vi: object?.display_name_vi ? object.display_name_vi : '',
    display_name_ko: object?.display_name_ko ? object.display_name_ko : '',
    display_name_zh_hant: object?.display_name_zh_hant ? object.display_name_zh_hant : '',
    display_name_zh_hans: object?.display_name_zh_hans ? object.display_name_zh_hans : '',
    note: object?.note ? object.note : '',
    delete_flg: false,
    code: object?.code ? object.code : '',
  };

  function onClose(status: boolean, data: DisplayControlGroup) {
    handleCloseModalEdit && handleCloseModalEdit(true, data);
  }

  async function HandleSubmitForm(values: DisplayControlGroup) {
    await service
      .updateDisplayControlGroup(values)
      .then((res) => {
        setDataTable && setDataTable(res.data);
        return res.data;
      })
      .then((data) => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal
              onClose={onClose.bind(null, true, data[0])}
              title={t('DisplayControlGroup.Validator.success')}
              message={t('DisplayControlGroup.Validator.add_success')}
            ></AlertModal>
          ));
      })
      .catch((error) => {
        console.log(error);
        showGlobalModal(() => (
          <AlertModal
            title={t('DisplayControlGroup.Validator.error')}
            message={JSON.stringify(error.response.data)}
          ></AlertModal>
        ));
      });
  }

  return (
    <Formik validationSchema={schema} onSubmit={HandleSubmitForm} initialValues={initialValues}>
      {({ handleSubmit, handleChange, values, errors, setFieldValue }) => {
        return (
          <Form noValidate onSubmit={handleSubmit}>
            <Form.Group as={Row} className="mb-3">
              <Col sm={10} md={10} lg={10} xl={10}>
                <div dangerouslySetInnerHTML={{ __html: t('DisplayControlGroup.Headers.Desc') }}></div>
              </Col>
              <Col style={{ textAlign: 'right' }}>
                <Button
                  className="pull-right"
                  onClick={() => {
                    handleSubmit();
                  }}
                  variant="success"
                >
                  {t('DisplayControlGroup.Button.keep')}
                </Button>
              </Col>
            </Form.Group>
            <Table bordered className="table-genre">
              <tbody>
                <tr>
                  <th colSpan={3} style={{ backgroundColor: '#36489a', width: '50%' }}>
                    {t('DisplayControlGroup.Form.name')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} rowSpan={7}>
                    {t('DisplayControlGroup.Form.display_name')}
                  </th>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('DisplayControlGroup.Form.display_name_ja')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      value={values.display_name_ja}
                      onChange={handleChange}
                      name="display_name_ja"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('DisplayControlGroup.Form.display_name_en')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      value={values.display_name_en}
                      onChange={handleChange}
                      name="display_name_en"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('DisplayControlGroup.Form.display_name_zh_hans')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="display_name_zh_hans"
                      value={values.display_name_zh_hans}
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('DisplayControlGroup.Form.display_name_zh_hant')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="display_name_zh_hant"
                      value={values.display_name_zh_hant}
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('DisplayControlGroup.Form.display_name_ko')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="display_name_ko"
                      value={values.display_name_ko}
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('DisplayControlGroup.Form.display_name_vi')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="display_name_vi"
                      value={values.display_name_vi}
                      onChange={handleChange}
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={3}>
                    {t('DisplayControlGroup.Form.note')}
                  </th>
                  <td>
                    <Form.Control as="textarea" onChange={handleChange} value={values.note} name="note" rows={3} />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Form>
        );
      }}
    </Formik>
  );
}

export default FormDetail;
